import * as React from "react"
import { Route, Switch } from "react-router-dom"
// import Dashboard from "./dashboard"
import Apis from "./apis"
import Faq from "./faq"
import GetStarted from "./get-started"
import HowItWorks from "./how-it-works"
import ExchangeRates from "./features/exchange-rates"
import CreditInterestRates from "./features/credit-interest-rates"
import CreditPaymentPlan from "./features/credit-payment-plan"
import DemoForm from "./demo-form"
import SftpLogin from "./sftp-login"
import SftpForgotPassword from "./sftp-forgotPassword"
import SftpForgotPasswordMsg from "./sftp-forgotPassword-msg"
import SftpChangePassword from "./sftp-changePassword"
import SftpChangePasswordSmsOtp from "./sftp-changePassword-smsOtp"
import SftpChangePasswordSuccess from "./sftp-changePassword-success"
import SftpChangePasswordError from "./sftp-changePassword-error"


const Layout = () => {
  return (
    <Switch>
      <Route exact path="/" component={SftpLogin} />
      <Route path="/apis" component={Apis} />
      <Route path="/faq" component={Faq} />
      <Route path="/get-started" component={GetStarted} />
      <Route path="/how-it-works" component={HowItWorks} />
      <Route path="/features/exchange-rates" component={ExchangeRates} />
      <Route path="/features/credit-interest-rates" component={CreditInterestRates} />
      <Route path="/features/credit-payment-plan" component={CreditPaymentPlan} />
      <Route path="/demo-form" component={DemoForm} />      
      {/* <Route path="/sftp-login" component={SftpLogin} /> */}
      <Route path="/sftp-forgotPassword" component={SftpForgotPassword} />
      <Route path="/sftp-forgotPassword-msg" component={SftpForgotPasswordMsg} />
      <Route path="/sftp-changePassword" component={SftpChangePassword} />
      <Route path="/sftp-changePassword-smsOtp" component={SftpChangePasswordSmsOtp} />
      <Route path="/sftp-changePassword-success" component={SftpChangePasswordSuccess} />      
      <Route path="/sftp-changePassword-error" component={SftpChangePasswordError} />
     
      
      
    </Switch>
  )
}

export default Layout
